if (!customElements.get('bundle-savings-progress')) {
  class BundleSavingsProgress extends HTMLElement {
    static calculate(cart, config) {
      const items=(cart.items||[]).filter(i=>!i.gift_card&&!config.excludedVariants.includes(Number(i.variant_id))&&!config.excludedProducts.includes(Number(i.product_id)));
      const count=items.reduce((n,i)=>n+Number(i.quantity),0);
      const spend=items.reduce((n,i)=>n+Number(i.original_line_price),0);
      const reached=config.tiers.filter(t=>spend>=t[0]);
      const rate=reached.length?reached.at(-1)[1]:0;
      const missing=Math.max(0,config.minimumQuantity-count);
      const next=config.tiers.find(t=>t[0]>spend);
      if(missing){const target=reached.at(-1)||config.tiers[0];return {key:spend<config.tiers[0][0]?'both':'quantity',count:missing,rate:target[1],amount:Math.max(0,target[0]-spend),progress:Math.min(count/config.minimumQuantity,spend/target[0])*100};}
      if(!rate)return {key:'spend',amount:config.tiers[0][0]-spend,rate:config.tiers[0][1],progress:spend/config.tiers[0][0]*100};
      return {key:next?'next':'top',rate,nextRate:next?.[1],amount:next?next[0]-spend:0,progress:next?spend/next[0]*100:100};
    }
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.config=JSON.parse(this.querySelector('[data-progress-config]').textContent);
      this.strings=JSON.parse(this.querySelector('[data-progress-strings]').textContent);
      this.refresh();
    }
    static async refreshAll(){
      clearTimeout(this.timer);this.timer=setTimeout(async()=>{
        const version=++this.version;
        try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error('cart');const cart=await response.json();if(version!==this.version)return;
          document.querySelectorAll('bundle-savings-progress').forEach(w=>w.render(cart));
        }catch(_){if(version===this.version)document.querySelectorAll('bundle-savings-progress').forEach(w=>w.hidden=true);}
      },160);
    }
    refresh(){BundleSavingsProgress.refreshAll();}
    render(cart){
      if(!this.config||!this.config.retailAllowed||cart.currency!=='AUD'||!cart.item_count){this.hidden=true;return;}
      const result=this.constructor.calculate(cart,this.config);
      const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-AU',{style:'currency',currency:'AUD',currencyDisplay:'narrowSymbol'}).format(n/100);
      const values={count:result.count,amount:money(result.amount),rate:result.rate,nextRate:result.nextRate};
      const message=this.strings[result.key==='quantity'||result.key==='both'?result.key+(result.count===1?'_one':'_many'):result.key].replace(/\{(\w+)\}/g,(_,key)=>String(values[key]));
      this.querySelector('[data-progress-message]').textContent=message;
      this.querySelector('progress').value=Math.max(0,Math.min(100,result.progress));
      this.querySelector('progress').setAttribute('aria-label',message);
      this.hidden=false;
    }
  }
  BundleSavingsProgress.version=0;
  customElements.define('bundle-savings-progress',BundleSavingsProgress);
  for(const event of ['cart:updated','cart:refresh','cartUpdate','cmw:cart-refresh','pageshow'])document.addEventListener(event,()=>BundleSavingsProgress.refreshAll());
  window.addEventListener('pageshow',()=>BundleSavingsProgress.refreshAll());
  const connectCartEvents=()=>{if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>BundleSavingsProgress.refreshAll());};
  if(document.readyState==='complete')connectCartEvents();else document.addEventListener('DOMContentLoaded',connectCartEvents,{once:true});
}
